import api from "@helpers/api";

import { URLS } from "@constants/urls";

import { EmployeeSummaryType } from "@type/HRM/employee-summary";

export const getEmployeeSummary = (() => {
  return async (): Promise<{ data: EmployeeSummaryType[] }> => {
    return api.post(URLS.GET_EMPLOYEE_SUMMARY).then((response) => {
      return { data: response.data.result };
    });
  };
})();
